import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withFirebase } from 'react-redux-firebase';

import { ProjectForm } from '../../components/Project';
import JumperModal from '../../components/JumperModal';
import addHistoryRecord from '../../redux/actions/history';
import { OPERATION_TYPES } from '../../constants';

import { uploadFile } from '../../helpers/fileHelpers';

class ProjectEditContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const projectId = this.props.selected.key;
    const data = this.form.getModel();
    console.log('data before clearing', data);

    const clearedData = Object.keys(data).reduce((total, current) => {
      const tmp = { ...total };
      if (data[current]) {
        tmp[current] = data[current];
      }
      return tmp;
    }, {});

    console.log('data after clearing', clearedData);

    const dataChanged =
      Object.keys(clearedData).filter(field => clearedData[field] !== this.props.selected[field])
        .length > 0;

    console.log('data changed', dataChanged);

    if (dataChanged) {
      this.props.firebase
        .updateWithMeta(`projects/${projectId}`, clearedData)
        .then(() => {
          if (clearedData.favicon && clearedData.favicon.length > 0) {
            uploadFile(
              this.props.firebase,
              `files/${projectId}/favicon`,
              `/projects/${projectId}/favicon`,
              data.favicon[0],
            );
          }

          if (clearedData.branding_logo && clearedData.branding_logo.length > 0) {
            uploadFile(
              this.props.firebase,
              `files/${projectId}/branding_logo`,
              `/projects/${projectId}/branding_logo`,
              data.branding_logo[0],
            );
          }
        })
        .then(() => {
          this.props.addHistoryRecord(projectId, 'projects', OPERATION_TYPES.UPDATE);
        });
    }
    this.props.handleClose();
  }

  render() {
    return (
      <JumperModal
        open={this.props.isOpen}
        handleClose={this.props.handleClose}
        handleSubmit={this.handleSubmit}
        title={'Edit item'}
        maxWidth={'md'}
      >
        <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
          <ProjectForm
            data={this.props.selected}
            ref={(instance) => {
              this.form = instance;
            }}
            history={this.props.history}
            inPopup
          />
        </div>
      </JumperModal>
    );
  }
}

ProjectEditContainer.defaultProps = {
  isOpen: false,
  selected: {},
};

ProjectEditContainer.propTypes = {
  selected: PropTypes.shape(),
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired,
  firebase: PropTypes.shape().isRequired,
  // selectedKey: PropTypes.string.isRequired,
};

const mapStateToProps = (state, props) => {
  const { firebase, router } = state;
  return {
    auth: firebase.auth,
    location: router.location,
    // selected: firebase.data.editedProject,
    firebase: props.firebase,
    // selectedKey: state.projects.selectedProjects[0].key,
  };
};

const mapDispatchToProps = dispatch => ({
  addHistoryRecord: (id, recordType, operation) => {
    dispatch(addHistoryRecord(id, recordType, operation));
  },
});

// const populates = [{ child: 'favicon', root: 'files' }];

export default compose(
  withFirebase,
  connect(({ firebase }) => ({
    auth: firebase.auth,
  })),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ProjectEditContainer);



// WEBPACK FOOTER //
// ./src/containers/Project/ProjectEditContainer.js